function setUpMakeAnOfferCtas () {
  const makeAnOfferBtn = document.getElementById('vjs-make-an-offer-button')
  const makeAnOfferModal = document.getElementById('buyer-offer-modal')
  const closeCtas = document.querySelectorAll('#buyer-offer-modal .vjs-modal-close')
  if (!makeAnOfferBtn) return

  makeAnOfferBtn.addEventListener('click', () => {
    document.getElementById('vjs-login-modal-purpose').value = 'make-an-offer'
  })

  if (!makeAnOfferModal) return

  makeAnOfferModal.addEventListener('click', event => {
    if (event.target === makeAnOfferModal) {
      document.getElementById('vjs-login-modal-purpose').value = ''
    }
  })

  if (!closeCtas) return

  closeCtas.forEach(closeCta => {
    closeCta.addEventListener('click', () => {
      document.getElementById('vjs-login-modal-purpose').value = ''
    })
  })
}

function showMakeAnOfferModalAfterLogin () {
  const makeAnOfferFlag = document.querySelector('[data-id="make-an-offer-should-open"]')
  const makeAnOfferModal = document.getElementById('buyer-offer-modal')

  if (!makeAnOfferFlag) return
  if (!makeAnOfferModal) return

  makeAnOfferModal.classList.add('show')
}

function showConfirmationModalAfterOfferSent () {
  const offerModalConfirmation = document.querySelector('[data-id="offer-sent-confirmation"]')

  if (!offerModalConfirmation) return

  const confirmationModalContent = offerModalConfirmation.innerHTML
  const offerSentModal = document.getElementById('thank-you-modal')
  const offerSentModalBody = document.getElementById('thank-you-modal-body')

  offerSentModalBody.innerHTML = confirmationModalContent
  offerSentModal.classList.add('show')
}

export default function setUpMakeAnOffer () {
  setUpMakeAnOfferCtas()
  showMakeAnOfferModalAfterLogin()
  showConfirmationModalAfterOfferSent()
}
